import { computed } from 'vue'
import { openCookieSettings } from '~/composables/useCookieConsent.js'

const COLUMNS = [
  {
    titleKey: 'footer.tool',
    links: [
      { to: '/examples', key: 'nav.samples' },
      { to: '/#how', key: 'nav.how' },
    ],
  },
  {
    titleKey: 'footer.useCases',
    links: [
      { to: '/use-cases/people', key: 'useCases.people.short' },
      { to: '/use-cases/ecommerce', key: 'useCases.ecommerce.short' },
      { to: '/use-cases/photographers', key: 'useCases.photographers.short' },
      { to: '/use-cases/business', key: 'useCases.business.short' },
    ],
  },
  {
    titleKey: 'footer.company',
    links: [
      { to: '/success-stories', key: 'nav.cases' },
      { to: '/pricing', key: 'nav.pricing' },
      { to: '/contact', key: 'nav.contact' },
    ],
  },
]

const LEGAL_LINKS = [
  { to: '/legal', key: 'footer.legal' },
  { to: '/terms', key: 'footer.terms' },
  { to: '/privacy', key: 'footer.privacy' },
]

export function useFooter() {
  const { locale, locales, setLocale } = useI18n()
  const userChoice = useCookie('i18n_user_choice', { maxAge: 60 * 60 * 24 * 365 })

  const langs = computed(() =>
    locales.value.map((l) => ({ value: l.code, label: l.name || l.code })),
  )

  const onLocaleChange = (value) => {
    userChoice.value = '1'
    setLocale(value)
  }

  return {
    columns: COLUMNS,
    legalLinks: LEGAL_LINKS,
    locale,
    langs,
    onLocaleChange,
    openCookieSettings,
    year: new Date().getFullYear(),
  }
}
